<template>
  <div class="training">
    <el-row v-if="totalCount" v-loading="loading">
      <el-col
        :xs="24"
        :sm="24"
        :md="24"
        v-for="(item,index) in data"
        :key="index"
        style="margin: 10px 0 8px 0"
      >
        <el-card shadow="always">
          <div class="testIndex-content">
            <ul class="eil-list-ul">
              <!--<div class="con">-->
              <!--<label>{{item.evaluationPerson}}({{item.level}})</label>-->
              <!--</div>-->
              <!--<p>{{item.address}}</p>-->
              <li>
                <div class="clearfix">
                  <div class="eil-dv1">
                    <p class="p1">
                      <span class="sunTitle">{{item.name}}</span>
                      <!-- <span class="sunCost" v-if="item.fee">￥{{item.fee}}</span> -->
                    </p>
                    <p
                      class="p2"
                      style="margin-top: 8px;"
                    >报名时间：{{item.apply_start_time|dateformat("YYYY-MM-DD HH:mm:ss")}} 至 {{item.apply_end_time|dateformat("YYYY-MM-DD HH:mm:ss")}}</p>
                    <p
                      class="p2"
                      style="margin: 5px 0;"
                    >培训时间：{{item.opening_class_start_time|dateformat("YYYY-MM-DD HH:mm:ss")}} 至 {{item.opening_class_end_time|dateformat("YYYY-MM-DD HH:mm:ss")}}</p>
                    <p class="p2">培训地址：{{item.provinceName == item.cityName ?item.provinceName:item.provinceName+item.cityName}}{{item.districtName}}{{item.detail_addr}}</p>
                  </div>
                  <div class="count" style=" ">
                    
                    <span class="sunCost">--</span>
                    <!--<span class="sunCost" v-if="item.fee">￥{{item.fee}}</span>-->
                  </div>
                  <div class="eil-dv2">
                    <!-- <p class="sunAddress" v-if="item.detail_addr">
                          <i class="el-icon-location-outline"></i>
                          {{item.detail_addr}}
                    </p>-->
                    <p class="anniu">
                     
                      <el-button v-if="item.isStop" disabled
                        type="danger"
                        @click="signUp(item)"
                      >报名</el-button>
                      
                      <el-button v-else
                        type="danger"
                        @click="signUp(item)"
                      >报名</el-button>
                      
                      
                      
                      <!-- <el-button v-if="item.isStop" disabled type="info" style="width:150px;height:40px" >报 名 </el-button>
                      <el-button v-else type="danger" style="width:150px;height:40px" @click="signUp(item)">报 名 </el-button> -->
                      
                      
                      
                    </p>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <no-data v-else />
    <div class="pagination" style="margin-top:30px;text-align:center">
      <el-pagination
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="paging.limit"
        :total="totalCount"
        v-if="totalCount>6"
      ></el-pagination>
    </div>
    <role-permissions
      :dialogVisible="dialogVisible"
      @changeDialogVisible="changeDialogVisible"
      roleName="考评员"
    />
  </div>
</template>

<script>
import { GetExaminerClassList2 } from "@/api/admin/common.js";
import noData from "@/views/admin/components/noData.vue";
import rolePermissions from "@/views/admin/components/rolePermissions.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    noData,
    rolePermissions
  },
  computed: {
    ...mapGetters(["userRole", "personalInfo", "levels"])
  },
  data() {
    return {
      data: [],
      totalCount: 0,
      paging: {
        limit: 5,
        page: 1
      },
      loading: false,
      dialogVisible: false,
    };
  },
  created() {
    this.getList();
  },
  mounted() {
    this.searchBus.$on("SearchData", msg => {
      this.searchALLdata(msg);
    });
  },
  methods: {
    getList() {
      // 考评员列表
      this.loading = true;
      GetExaminerClassList2(Object.assign(this.paging))
        .then(data => {
          var list = data.data.result;
          if (list) {
            this.data = list.items;
            
            this.totalCount = list.totalCount;
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    // 分页
    handleCurrentChange(cpage) {
      this.paging.page = cpage;
      this.loading = true;
      GetExaminerClassList2(Object.assign(this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.loading = false;
        }
      });
    },
    // 搜索
    searchALLdata(msg) {
      
      this.loading = true;
      GetExaminerClassList2(Object.assign(msg, this.paging)).then(data => {
        var list = data.data.result;
        if (list) {
          this.data = list.items;
          this.totalCount = list.totalCount;
          this.loading = false;
        }
      });
    },
    //报名
    signUp(item) {
      if (this.userRole == 2) {
        this.$router.push({
          path: "/evaluationStaffTraining/evaluationStaffTrainingDetail",
          query: { id: item.id }
        });
      } else {
        this.dialogVisible = true;
      }
    },
    changeDialogVisible(val) {
      this.dialogVisible = val;
    }
  },
  beforeDestroy() {
    this.searchBus.$off("SearchData");
  }
};
</script>

<style lang="less" scoped>
.training {
  .el-card__body {
    padding: 0;
    .eil-list-ul {
      padding: 7px 0;
      li {
        cursor: pointer;
        position: relative;
        .p1 {
          font-size: 16px;
          color: #111;
          cursor: pointer;
          position: relative;
          .sunTitle {
            color: #151515;
            // float: left;
            display: inline-block;
            max-width: 500px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .sunCost {
            color: #f15660;
            font-size: 16px;
            margin-left: 20px;
            position: absolute;
            right: 5px;
          }
        }
        .p2 {
          font-size: 14px;
          color: #999;
        }
        .eil-dv1 {
          float: left;
          width: 60%;
        }
        .count {
          float: left;
          width: 20%;
          line-height: 94px;
          color: #f15660;
          text-align: center;
        }
        .eil-dv2 {
          float: left;
          width: 20%;
          .sunAddress {
            padding: 0px 0px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            font-size: 14px;
            color: #bbb;
          }
          .anniu {
            text-align: right;
            padding: 33px 0px 0px 0px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .training {
    .el-card__body {
      .eil-list-ul {
        li {
          .eil-dv1 {
            width: 100%;
          }
          .count {
            line-height:39px;
            text-align: left;
          }
          .eil-dv2 {
            width: 100%;
            .anniu{
              text-align: center;
              padding: 0;
            }

          }
        }
      }
    }
  }
}
</style>
